import ServiceBase from '../ServiceBase';

export default class BlogPostsService extends ServiceBase {
    constructor($http) {
        super($http);
    }

    /**
     * Fetches blog posts from the server.
     *
     * @param {Object} params - The parameters for the request.
     * @param {number} params.pageIndex - The index of the page to fetch.
     * @param {number} params.pageSize - The size of the page to fetch.
     * @returns {Promise} A promise that resolves to the response of the request.
     */
    getBlogPosts(params) {
        const { pageIndex = 0, pageSize = 4 } = params;
        return this.request('get', 'admin/blogposts/getBlogPosts', {
            pageIndex,
            pageSize,
        });
    }

    createBlogPost(blogPost) {
        const params = {
            ...blogPost,
        };

        return this.request('post', 'admin/blogposts/createBlogPost', params);
    }

    deleteBlogPost(blogPostID) {
        const params = {
            blogPostID,

        };

        return this.request('post', 'admin/blogposts/deleteBlogPost', params);
    }

    getBlogPost(blogPostID) {
        const params = {
            blogPostID,

        };

        return this.request('get', 'admin/blogposts/getBlogPost', params);
    }

    searchBlogPosts(filters = {}, pageSize = null, pageIndex = null) {
        const params = {

            pageSize,
            pageIndex,
            ...filters,
        };

        return this.request('post', 'admin/blogposts/searchBlogPosts', params);
    }

    updateBlogPost(blogPost) {
        const params = {
            ...blogPost,
        };

        return this.request('post', 'admin/blogposts/updateBlogPost', params);
    }

    isBlogPostUrlValid(blogPostID, urlName) {
        return this.request('get', 'admin/blogposts/isBlogPostUrlValid', { blogPostID, urlName });
    }

    sendNotification(blogPostID) {
        return this.request('post', 'admin/blogposts/sendNotification', { blogPostID });
    }

    searchBlogPostTags(filters = {}, pageSize = null, pageIndex = null) {
        const params = {

            pageSize,
            pageIndex,
            ...filters,
        };

        return this.request('post', 'admin/blogposts/searchBlogPostTags', params);
    }
}